import { computed, effect, Injectable, signal, untracked } from '@angular/core';

import type { ThemeType } from '../../types/theme.type';
import { AvailableThemes } from '../../types/theme.type';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private _theme = signal<ThemeType>('auto');
  readonly theme = this._theme.asReadonly();
  setTheme = (theme: ThemeType): void => {
    this._theme.set(theme);
  };

  readonly resolvedTheme = computed(() => {
    const current = this._theme();
    if (current === 'auto') {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }

    return current;
  });

  constructor() {
    effect(() => {
      const theme = this._theme();
      untracked(() => this.applyTheme(theme));
    });
  }

  private applyTheme(theme: ThemeType): void {
    const htmlElement: HTMLElement | null = document.querySelector('html');
    if (htmlElement) {
      htmlElement.classList.remove(
        ...AvailableThemes.map((possibleTheme) => `${possibleTheme}-theme`),
      );
      htmlElement.classList.add(`${theme}-theme`);
    }
  }
}
